/*
 * Measurement Point List Layout sets up the two column full screen view for filling out Measurement Points
 */

import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { getFilteredInstallBasesNotComplete } from '../../reducers/manageInventoryReducer';
import { partTypeEnum } from '../../models-enums';

import { IinitialState } from '../../reducers';
import { IinstallBase, IinstallBasePopulated, Ipart } from '../../models';
import { LeftColumnContainer } from './LeftColumnContainer';
import { MeasurementPointListContainer } from './MeasurementPointListContainer';
import { RouteComponentProps } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import ConfirmSelectJobModal from '../workOrder/ConfirmSelectJobModal';
import { SearchAllPartsModalandContainer } from '../parts/SearchAllPartsModalandContainer';
import { suggestedPartsQueryParamsEnum } from '../parts/SuggestedParts';
import { constants } from '../../constants/constants';
import queryString from 'query-string';
import { savePartAsInstallBasePart } from '../../actions/partsActions';
import { getIsMobile, getIsTablet } from '../../reducers/configReducer';
import MobileLayout from './Mobile/Layout';
import { initialInstallBase } from '../../reducers/initialState';
import styled from 'styled-components';

/*
 * MMG-4437: these columns start below the 60px app header, so 100dvh runs 60px past the bottom of
 * #root (which is overflow:hidden) and that last 60px of the form can never be scrolled to. The
 * available height is the viewport minus the header - @headerHeight in less/variables.less.
 */
const COLUMN_HEIGHT = 'calc(100dvh - 60px)';

const LeftCol = styled(Col)`
    height: ${COLUMN_HEIGHT};
    overflow-y: auto;
    overflow-x: hidden;
`;

const RightCol = styled(Col)`
    height: ${COLUMN_HEIGHT};
    display: flex;
    flex-direction: column;
    overflow: hidden;
    
    & > * {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
    }
`;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Iprops extends RouteComponentProps<{ installID: string }> {
    // t: TFunction;
}

interface IdispatchProps {
    installBasesNotTested: IinstallBasePopulated[];
    installBaseIDsNotTested: string[];
    showAddRepairWorkOrderModal: boolean;
    installBase: IinstallBase;
    facilityID: string;
    queryParams: typeof suggestedPartsQueryParamsEnum;
    savePartAsInstallBasePart: typeof savePartAsInstallBasePart;
}

const MeasurementPointListLayoutC = (props: Iprops & IdispatchProps) => {
    const colorButton = constants.colors[`blueButton`];
    const handlePartSearchSubmit = (part: Ipart) => {
        props.savePartAsInstallBasePart(part, props.match.params.installID, part.quantity);
    };

    const isMobile: boolean = useSelector(getIsMobile);
    const isTablet: boolean = useSelector(getIsTablet);
    if (isMobile || isTablet) {
        return <MobileLayout {...props} />;
    }

    return (
        <Row>
            <LeftCol xs={4} lg={3} xl={4} style={{ paddingRight: '0' }}>
                <LeftColumnContainer {...props} />
            </LeftCol>
            <RightCol xs={8} lg={9} xl={8} className="mp-right-column">
                <MeasurementPointListContainer {...props} />
            </RightCol>
            <ConfirmSelectJobModal
                selectedInstallID={props.match.params.installID}
                facilityID={props.facilityID}
                history={props.history}
                location={props.location}
                match={props.match}
                forSAP={false}
            />
            <SearchAllPartsModalandContainer
                colorButton={colorButton}
                onSubmit={handlePartSearchSubmit}
                shouldShowQuantity={true}
                partType={partTypeEnum.default}
            />
        </Row>
    );
};

const makeMapStateToProps = () => {
    const mapStateToProps = (state: IinitialState, ownProps: Iprops) => {
        const queryParams = queryString.parse(ownProps.location.search) as typeof suggestedPartsQueryParamsEnum;
        // const isWorkOrderTypeJob = getIsWorkOrderTypeJob(state);
        // let tableFilterOverrides: ItableFiltersParams = {
        //     measurementPointListResultStatus: {
        //         value: measurementPointResultStatusTypesEnum.resultStatusNotTested,
        //         label: ''
        //     }
        // };

        // if (isWorkOrderTypeJob) {
        //     tableFilterOverrides = {
        //         workOrderResultStatus: {
        //             value: workOrderStatusEnumForFilter.open,
        //             label: ''
        //         }
        //     };
        // }

        const installBasesNotTested = getFilteredInstallBasesNotComplete(state);
        const installBaseIDsNotTested = installBasesNotTested.map(install => install.id);
        const installBase =
            state.manageInventory.installBasesByID[ownProps.match.params.installID] || initialInstallBase;
        const facilityID = state.manageJob.selectedJob.facilityID;

        return {
            installBasesNotTested,
            installBaseIDsNotTested,
            showAddRepairWorkOrderModal: state.workOrder.showAddRepairWorkOrderModal,
            installBase,
            facilityID,
            queryParams
        };
    };
    return mapStateToProps;
};

export const MeasurementPointListLayout = connect(makeMapStateToProps, {
    savePartAsInstallBasePart
})(MeasurementPointListLayoutC);
